export const SV = {
  message: {
    banner:
      "Due to a technical issue, all the data cannot be published. We are working on it. We apologise for the inconvenience.",
    in: "En",
    loadingText: "Chargement des données ...",
    selectCustomer: "välja en klient",
    offline: "Webbplatsen är under underhåll",
    refer: "Hänvisa till användarvillkoren",
    error: {
      userNotFound: "Aucun utilisateur trouvé",
      noToken: "Ce lien n'est plus valide",
    },
    alert: {
      mail: "Enable mail alert",
      sms: "Enable SMS alert",
      battery: "battery alerts",
      disclamer:
        "based on thresholds defined by Akiem Leasing and concerning locomotives fitted with Railster boxes",
      sralert: "Varning",
      toggleAlert:
        "Genom att aktivera det här alternativet får du ett e-postmeddelande för varje varning som skickas från MyFleetHub",
      quotation: "Quotation alert",
      quotationLabel:
        "genom att aktivera detta alternativ kommer du att få ett e-mai-meddelande för varje ny offert som publiceras på MyFleetHub",
    },
    select: "Tout cocher",
    ssoLogin: "Logga in med azure AD",
    rgpd:
      "Akiem förbinder sig att på ett opartiskt och transparent sätt följa lagstiftningen om skydd av personuppgifter, i synnerhet " +
      "allmänna dataskyddsförordningen (”GDPR”). Vi använder inga cookies på denna Portal. Därmed kommer inga av dina personuppgifter " +
      "att samlas in medan du är uppkopplad eller lagras efter avslutad uppkoppling. Ditt samtycke kommer uttryckligen att begäras om du " +
      "skulle vilja använda funktionen ”undersökning av kundtillfredsställelse",
    login: {
      welcomeFirst: "välkommen till",
      welcomeSecond: "espace client",
      id: "Användarnamn",
      pw: "Lösenord",
      restore: "återställa lösenordet",
      validate: "Bekräfta",
      errorLogin: "Le mot de passe est éronné, merci de recommencer",
      initMsg:
        "Veuillez renseigner votre mot de passe pour finaliser la creation de votre compte",
    },
    aside: {
      home: "Hem",
      notice: "Användaranvisningar",
      logout: "Logga ut",
      account: "Mitt konto",
      config: "Configuration",
      profil: "Profilinformation",
      alert: "Mes alertes",
      parc: "Min fordonspark",
      planning: "Mon planning",
      detail: "Uppgifter om min fordonspark",
      geo: "Geografisk lokalisering av min materiel",
      board: "Kontrollpanel",
      km: "Information km",
      hm: "Motortimmar",
      battery: "Battery info",
      mint: "My MINT",
      magic: "Underhållsarbeten ",
      history: "Historik",
      infoloc: "Information om lok",
      fleetcontrol: "Kontroll av flottan",
      unleased: "Icke leasad flotta",
      doc: "Mina dokument",
      edl: "Inventarier / Certifikat",
      certificat: "Certifikat",
      jobplan: "Förfallodagar för underhål",
      krefeldplan: "Krefeld plan",
      batterytable: "Latest battery readings",
      geofencing: "Geofencing",
      disponibility: "Avtalsenlig tillgänglighet",
      admin: "Internal menu",
      locoInternal: "Skapa ett supportärende",
      userlist: "Användarlista"
    },
    superuser: {
      profile: "Profil",
      action: "Handling",
      updateprofile: "Utgåva",
      administrator: "Administratör",
      management: "Förvaltning",
      operational: "Operativ",
      commercial: "Kommersiell",
      delmessage1: "Du är på väg att begära radering av konto",
      delmessage2:
        "Ett meddelande kommer att skickas till Akiems IT-avdelning som kommer att radera kontot.",
      delmessage3:
        "kommer inte längre att ha tillgång till kundportalen My Fleet hub. Om användaren vill skapa ett nytt konto vid ett senare tillfälle ska han/hon kontakta sin Service Contract Manager. Vill du fortsätta?",
      legendmgt:
        "Hanteringsprofilen kan konsultera alla portalmoduler. De kan validera extra arbete.",
      legendcom:
        "Säljprofilen kan konsultera alla portalmoduler. De kan inte validera extra arbete.",
      legendoper:
        "Den operativa profilen kan konsultera alla portalmoduler utom modulen « mitt extraarbete ».",
    },
    geofencing: {
      select: "Please select a value",
      entry: "Entry date and time",
      exit: "Exit date and time",
      dbenergy: "Have you thought about making your DB energy declaration?",
    },
    header: {
      language: "Språk",
    },
    home: {
      team: "Mitt särskilt avdelade Akiem-team",
      name: "Namn",
      firstname: "Förnamn",
      function: "Befattning",
      fixphone: "Fast telefon",
      mobilephone: "Mobiltelefon",
      mail: "E-postadress",
      locoInfo: "Skapa en snabb serviceförfrågan",
    },
    page: {
      assignment: "Tilldelning",
      customer: "Portail",
      portal: "Client",
      availableLoco: "Upprätthålls av AKIEM",
      loconumber: "Lokomotivnummer",
      status: "Driftstatus",
      available: "Tillgängligt",
      maintenance: "Underhåll pågår",
      connexionDate: "Datum för senaste inloggning",
      findLocation: "Lokalisering av rullande material",
      contractNumber: "Kontraktsnummer",
      serial: "Série",
      contractStatus: "Kontraktsvillkor",
      startDate: "Startdatum",
      endDate: "Slutdatum",
      delta:
        "En sélectionnant une plage de dates, vous obtiendrez un tracé de votre parcours",
      locate: "Lokalisering",
      titular: "Ordinarie",
      reserve: "Reserv",
      spot: "Spot",
      performance: "Prestanda",
      cumulTitle: "Kilomètres cumulés par locomotive",
      cumul: "Ackumulerade km",
      distance: "Avstånd",
      moyMonth: "Körda kilometer i genomsnitt / månad",
      filterMsg: "om du markerar ett enda lokomotiv visas din körsträcka",
      availableNotice: '"Ne comprend pas les signalements en compte"',
      doctype: "Typ av dokument",
      contractType: "Contract type",
    },
    opinionGlobal: {
      opinion: "mina synpunkter på portalen",
      opinionFirst: "Mina synpunkter",
      opinionSecond: "På portalen",
      opinionRedirectionOne: "du kommer att omdirigeras till en extern sida,",
      opinionRedirectionTwo: "vill du fortsätta?",
      opinionClic:
        "Om du klickar på denna länk accepterar du att lämna denna portal och komma in på plattformen " +
        "Eval N Go för att undersökningen om kundtillfredsställelse ska kunna genomföras och samtycker därmed " +
        "till behandlingen av dina personuppgifter.",
      opinionPersonelData:
        "De nödvändiga personuppgifter som samlas in är följande :",
      opinionMail: "E-postadress",
      opinionName: "Namn",
      opinionDataTransmission:
        "Uppgifterna överförs endast till behöriga personer hos Akiem vilka omfattas av tystnadsplikt." +
        " Uppgifterna kommer att sparas under 1 år.",
      opinionStock:
        "De förvaras i Frankrike och kommer inte att överföras till länder utanför EU.",
      opinionRules:
        "I enlighet med gällande lag har du rätt till kontroll över dina personuppgifter " +
        "(rätt till tillgång, rättelse etc.) som du kan utöva genom att skicka ett e-brev till dpo@akiem.com",
      opinionHelp:
        "Genom att göra det hjälper du oss att utvecklas ytterligare för att ge dig stöd och " +
        "vägledning och bättre förstå dina behov, ditt bidrag är en värdefull hjälp.",
      opinionYes: "Ja",
      opinionNo: "Nej",
    },
    pageKm: {
      trackingKm: "Suivi des kilomètres",
      tableKm: "Tableau des kilomètres",
      status: "Kontraktsvillkor",
      serial: "Serienummer",
      contract: "Contrats",
      contractnum: "Kontraktsnummer",
      total: "Avstånd totalt",
      loco: "Lokomotiv",
      date: "Datum",
      since: "Sedan den",
      kmNotice: '"Kilomètres relevés selon les données Railster transmises" ',
    },
    pageHm: {
      title: "Motortimmar",
      lastcheck: "Latest data",
      cumulativeHm: "ackumulerade motortimmar",
      hm: "Engine hours",
      total: "Totalt antal förbrukade motortimmar",
      portalReal: "Readings taken from the portal",
      maintenanceReal: "Readings taken during maintenance",
      detailHm: "Uppgifter om motortimmar",
    },
    maintenance: {
      workshops: "Underhållsverkstäder",
    },
    pageAlert: {
      alert: "Mes alertes",
      inout: "ENTREE ET SORTIE LOCOMOTIVE",
      serial: "Sur une série",
      contract: "Sur un contrat",
      loco: "Sur les locs de mon parc",
      mail: "Activer alertes mail",
      sms: "Activer alertes sms",
      battery: "ALERTES BATTERIE",
    },
    passwordResetPage: {
      first: "Veuillez renseigner votre mot de passe",
      confirm: "mot de passe confirmation",
      pwRuleOne: "mot de passe requis",
      pwRuleTwo: "8 caractères minimum",
      pwRuleThree:
        "Le mot de passe doit contenir au moins une lettre minuscule, un chiffre, un caractère spécial et une lettre majuscule",
      pwConfirmOne: "la confirmation du mot de passe est requise",
      pwConfirmTwo: "La confirmation du mot de passe ne correspond pas",
      pwSuccess: "Mot de passe reinitialisé avec success",
      validate: "Valider",
    },
    pageNotice: {
      second:
        "Uppgifterna, informationen och/eller dokumenten som finns på denna Portal och/eller " +
        "är tillgängliga genom Portalen är endast publicerade som exempel och i informationssyfte och är inte bindande.",
      third:
        "Uppgifterna, informationen och/eller dokumenten kan innehålla fel och oriktigheter. De kan när som helst ändras eller uppdateras " +
        "av Akiem. Vi rekommenderar dig att alltid kontrollera att uppgifterna, informationen och/eller dokumenten som tillhandahålls " +
        "via denna Portal är exakta och relevanta.",
      fourty:
        "Portalens Användare bär själv hela ansvaret för användningen av uppgifterna, informationen och/eller dokumenten som finns på Portalen" +
        " och användaren påtar sig alla konsekvenser som det kan resultera i utan att något ansvar kan tillskrivas Akiem på denna grund och utan " +
        "att någon talan kan föras mot Akiem.",
      fifty:
        "Akiem kan under inga omständigheter ställas till svars för eventuella skador av något slag som följder av en tolkning eller användning " +
        "av informationen och/eller dokumenten som tillhandahålls via denna Portal.",
      sixty:
        "Portalen är som regel tillgänglig dygnet runt, 7 dagar i veckan, förutom i fall av force majeure eller vid en händelse som ligger utanför " +
        "Akiems kontroll och med reservation för eventuella störningar och underhållsarbeten som är nödvändiga för att Portalen ska fungera korrekt, för Användare " +
        "som har en internetuppkoppling. Akiem förbehåller sig möjligheten att när som helst och utan föregående meddelande stoppa, tillfälligt avbryta eller förändra " +
        "tillgången till hela eller delar av Portalen i syfte att säkerställa underhållet, eller av något annat skäl, utan att avbrottet ger upphov till någon skyldighet eller rätt till någon ersättning.",
      seventy:
        "Akiem förbinder sig att på ett opartiskt och transparent sätt följa lagstiftningen om skydd av personuppgifter, i synnerhet allmänna dataskyddsförordningen (”GDPR”). " +
        "Akiem har vidtagit tekniska och organisatoriska åtgärder för att se till att Användarens uppgifter är skyddade mot obehörig åtkomst, liksom andra it-säkerhetsrisker och it-sårbarheter.",
      eighty:
        "Vi använder inga cookies på denna Portal. Därmed kommer inga av dina personuppgifter att samlas in medan du är uppkopplad eller lagras efter avslutad uppkoppling. " +
        "Ditt samtycke kommer uttryckligen att begäras om du skulle vilja använda funktionen ”undersökning av kundtillfredsställelse”",
    },
    magic: {
      workorderTitle: "Underhållets titel",
      workorder: "Underhållets",
      startDate: "Startdatum",
      endDate: "Slutdatum",
      meter: "Kilometer",
      hours: "Motortimmar",
      technicDoc: "Teknisk dokumentation",
      restriction: "Restriction/Reason",
      date: "Datum",
      asset: "Materiel roulant",
      km: "KM",
      leftD1: "D1 gauche",
      leftD2: "D2 gauche",
      leftD3: "D3 gauche",
      leftD4: "D4 gauche",
      rightD1: "D1 droit",
      rightD2: "D2 droit",
      rightD3: "D3 droit",
      rightD4: "D4 droit",
      action: "Action",
      description: "Översikt-plats",
      desc: "Översikt",
      addFile: "Lägg till en bilaga ",
      reportBy: "Report by",
      id: "ID",
      status: "Status",
      sr: "Varning",
      srAttechement: "Tillhörande varningar",
      attachements: "Bilagor",
      mileage: "dataregister",
      createAlert: "Skapa en varning",
      title: "Titel",
      location: "Plats",
      priority: "Prioritet",
      addKm: "Skicka en sammanställning",
      newKm: "Nytt värde",
      lastreading: "Aktuellt värde",
      scheduleDate: "Planerade datum ",
      metername: "Yyp av sammanställning",
      executeDate: "Datum för genomförande ",
      error: "åtgärden misslyckades ",
      success: "åtgärden är registrerad",
      attachment: "Lägg till en bilaga ",
      unit: "Enhet",
      source: "Källa",
      jobplan: "Job plan type",
      type: "Typ",
      reportedDate: "Datum för skapandet",
      details: "Detaljer",
      hotline: "Hotline-biljett",
    },
    assetStatus: {
      operating: "Operating",
      maintenance: "Maintenance",
      limitedUse: "limited use",
      blocked: "Blocked",
    },
    button: {
      submit: "Bekräfta",
      cancel: "ångra",
    },
    search: "Sökning",
    history: {
      pm: "Historik över förebyggande underhåll",
      cm: "Historik över avhjälpande underhåll",
    },
    infoloc: {
      infoOp: "Driftsinformation",
      infoTech: "Teknisk information ",
      cert: "Typgodkännanden",
      openSr: "Signalements ouverts",
      sr: "Varningar",
      dateAndKm: "Datum och körsträcka i km",
      pmPlan: "Plan de maintenance prévisionnelle",
      locomotive: "Lokomotiv",
      actWorkorder: "Pågående underhåll",
      outPrevDate: "Förväntat datum för utgivning",
      nextWorkDate: "Nästa underhåll",
      wheelset: "Information om axel",
      unitToGo: "Resterande kilometer",
      engineeringvariant: "Engineering variant",
      softwareversion: "Software version",
      hkm: "historik över körsträcka",
      hhm: "historik över motortimmar",
      fuellevel: "Fioul level",
      parking: "avstängt",
      traction: "rör sig i dragkraft",
      vehicle: "rör sig - fordon",
      poweron: "på men rör sig inte",
      standby: "dieselmotor på utan rörelse",
    },
    status: {
      approved: "Confirmed appointment",
      canceled: "Cancelled",
      ccanceled: "Appointment canceled by customer",
      completed: "Status according desicion ECM 3",
      inprogress: "Under maintenance",
      wait: "forcast planing, upcoming maintenance",
      new: "New",
      sinprogress: "In progress",
      closed: "Closed",
    },
    woStatus: {
      WSCH: "Waiting to be scheduled",
      WAPPR: "Waiting to be scheduled",
      WPCOND: "Waiting to be scheduled",
      CLOSE: "Done",
      COMP: "Done",
      INPRG: "Under maintenance",
      REVIEWED: "Done/ In waiting for ECM3 release",
      WCOE: "In waiting for cost or material",
      WMATL: "In waiting for cost or material",
      APPR: "Approved",
      CA: "Cancelled",
      NOTPERF: "Not performed",
      CAN: "Cancelled",
    },
    doc: {
      certificat: {
        delivry: "Leveransintyg",
        redelivry: "Returintyg ",
        genralInfo: "GENERAL INFORMATION",
        technicalInfo: "TECHNICAL DATA",
        signature: "SIGNATURES",
        asOf: "As of ",
        andAccording: "and in accordance with the provisions",
        contractRes: "contract/reservation ",
        representBy: "the company Akiem SAS represented by Sebastian Rodriguez",
        delivryTo: "delivers to the company",
        delivryToAkm:
          "has delivered to Akiem represented by Sebastian Rodriguez ",
        locomotive: "the locomotive",
        delivryAt: "delivered to the site of ",
        restDerog: "Restrictions/ limited used",
        comment: "Comments",
        edl: "Hand over document attached",
        remark: "Note",
        rem1: "Subject to contractual provisions, this locomotive must be insured from the date of delivery shown on the certificate at the latest.",
        rem2: "Custody of the locomotive passes to the lessee on the delivery date stated in this certificate",
        kmCompteur: "Km odometer",
        hmMoteur: "Engine hours",
        wheelset: "Axles",
        recentData: "most recent data*",
        lastRecord: "last recorded on ",
        date: "Date",
        defaultMes:
          "If no reservation is received within 48 hours, this certificate will be considered final.",
        addBill:
          "You may be billed for any additional costs incurred in refurbishing the locomotive. ",
        yes: "YES",
        no: "NO",
        reserv: "To send a reserve",
        reject: "Reserves issued",
      },
      type: "Typ av dokument",
      edl: {
        delivry: "Leveransförklaring",
        redelivry: "Leveransförklaring",
      },
    },
    doctypes: [
      {
        key: "DELIVERY (EXCEPT NEW)",
        value: "Leveransförklaring",
      },
      {
        key: "REDELIVERY,RESTITUTION",
        value: "Leveransförklaring",
      },
      {
        key: "Prima Delivery Certificate,Traxx Delivery Certificate",
        value: "Leveransintyg",
      },
      {
        key: "Prima Redelivery Certificate,Traxx Redelivery Certificate",
        value: "Returintyg",
      },
    ],
    poi: {
      workshop: "Entrance/Exit Workshop",
      entry: "Estimated entry on",
      exit: "Exit estimated on",
      at: "at",
    },
    extrawork: {
      title: "My Extra-works",
      newquote: "Nya citat",
      quotewaiting: "I väntan på validering",
      messageconfirm: "Vänligen ange ditt beställningsnummer",
      confirm: "Bekräfta",
      reject: "Reject",
      cancel: "Avbryt",
      whyreject: "Varför vill ni förkasta offerten? ",
      rejectcomment: "vänligen lämna en kommentar",
      quotenum: "Notering nr.",
      quotetitle: "Offerttitel",
      quoteprice: "Pris exkl. moms",
      quotestatus: "Status för offert",
      realisationdate: "Faktiskt genomförande",
      customerpo: "Kund Po",
      tovalidate: "Väntar på validering",
      validated: "Accepterad",
      rejected: "Avvisad",
      quoterejected: "Avvisad",
      quotesrejected: "Avvisade offerter",
      comment: "Kommentar",
      unitprice: "Enhetspriser",
      service: "Tjänster",
      quantity: "Kvantitet",
      totalprice: "Totalt pris",
      quotetotalprice: "Total kostnad för offert",
      statusbilled: "fakturering",
      statusvalidated: "validerad",
    },
    dispoc: {
      past: "Visa passerade uppdrag",
      widgetText: "Se min avtalsenliga tillgänglighet",
      taux: "Taux",
      recapLoc: "Tillgänglighet",
      ticmp: "Förebyggande stillestånd",
      timcc: "Korrigerande stilleståndstid",
      ticc: "Kund stilleståndsfrekvens",
      locDisp: "Tillgänglig",
      locTot: "Totalt",
      week: "Vecka",
      ldispo: "Tillgänglig",
      ldmd: "Tillgänglig i försämrat läge",
      lmp: "Förebyggande underhåll",
      lmc: "Korrigerande underhåll",
      lach: "Routning",
      lmcc: "Kundkorrigerande underhåll",
      indisponibilite: "Otillgänglighet",
      dispGen: "Global tillgänglighet",
      causeCorrective: "avhjälpande underhåll",
      causePreventive: "förebyggande underhåll",
      causeClient: "för kund",
    },
    restriction: {
      title: "Begränsning i",
      partial: "Delvis begränsning",
      total: "Total begränsning",
      dates: "Från {start} till {end}",
    },
  },
  country: {
    AT: "Österrike",
    BE: "Belgien",
    CH: "Schweiz",
    CZ: "Tjeckien",
    DE: "Tyskland",
    DK: "Danmark",
    FR: "Frankrike",
    HR: "Kroatien",
    HU: "Ungern",
    IT: "Italien",
    LU: "Luxemburg",
    MA: "Marocko",
    NL: "Nederländerna",
    PL: "Polen",
    RO: "Rumänien",
    SE: "Sverige",
    SK: "Slovakien",
    SI: "Slovenien",
    RS: "Serbien"
  },
};

export default SV;
